// extracted by mini-css-extract-plugin
module.exports = {"crossedPrice":"_2u4DN3","shine-lines":"_3v5689"};